<script context="module">
  import { fly, fade } from 'svelte/transition';
  import { writable } from 'svelte/store';
  import { Toast, ToastBody, ToastHeader } from 'sveltestrap';

 const toastStore = writable({
   visible: false
  });

  export const toast = (color, timeout, header, message) => {
    toastStore.set({
      color,
      header,
      message,
      visible: true
    });
    setTimeout(() => {
      toastStore.set({visible: false})
    }, timeout)
  }

  export const stickyToast = (color, header, message) => {
    toastStore.set({
      color,
      header,
      message,
      visible: true
    });
  }

  export const clearToasts = () => toastStore.set({visible: false});
</script>

{#if $toastStore.visible}
  <div class="p-3 mb-3" 
    style="position: fixed; top: 0; right: 0; z-index: 2000;" 
    in:fly="{{ x: 200, duration: 500 }}" 
    out:fade
    on:click="{clearToasts}">
    <Toast class="mr-1">
      <ToastHeader>
        {$toastStore.header}
      </ToastHeader>
      <ToastBody class='bg-{$toastStore.color}'>
        <div class='d-flex align-items-center text-white'>
          <i class="fas fa-check fa-2x mr-2"></i>
          <p>{$toastStore.message}</p>
        </div>
      </ToastBody>
    </Toast>
  </div>
{/if}